export const taskManager = () => {
  const tasks = [];

  return {
    get: () => tasks,
    empty: () => tasks.length === 0,
    add: (task) => tasks.splice(0, tasks.length, task),
    pop: () => tasks.pop(),
  };
};
